/*
  Star rating — the jump to reviews.

  The count is a real link to the product page's reviews. Only a product page scrolls: the
  click is taken over and the page moves, which is what Klaviyo's own star widget does.
  Everywhere else it navigates — from a collection, where the section is not on the page, and
  from inside the quick add sheet, which can be open over a product page whose reviews are
  not the ones the sheet is showing.

  The reviews themselves are an app block the theme does not render, so there is no id to
  point at. The target is found by looking for Klaviyo's own container first and falling back
  to the app block wrapper Shopify puts around every app block.
*/
(function () {
  if (window.__productStars) return;
  window.__productStars = true;

  var HASH = '#reviews';

  /* Klaviyo's own container first — it renders `#fulfilled-reviews-all`, carrying the
     product id. An explicit `[data-product-reviews]` beats everything, so the theme can name
     the target outright if the app's markup ever changes. */
  var TARGETS = [
    '[data-product-reviews]',
    '#fulfilled-reviews-all',
    '[id^="fulfilled-reviews"]',
    '#klaviyo-reviews',
    '.klaviyo-reviews',
    '[class*="kl-reviews"]',
  ];

  function reviews() {
    for (var i = 0; i < TARGETS.length; i++) {
      var named = document.querySelector(TARGETS[i]);
      if (named) return named;
    }

    /* Last app block on the page. The wishlist button is one too and sits beside the stars,
       so taking the first match scrolled a few pixels and read as the page refusing to move.
       Reviews are below the buy panel, so the last one is the right end to search from. */
    var blocks = document.querySelectorAll('.shopify-app-block');
    for (var j = blocks.length - 1; j >= 0; j--) {
      if (!blocks[j].closest('[data-product-form]')) return blocks[j];
    }
    return null;
  }

  function scrollTo(target) {
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // The header is sticky, so scrollIntoView would park the reviews underneath it.
    var bar = document.querySelector('.header__bar');
    var clearance = (bar ? bar.getBoundingClientRect().height : 0) + 16;
    var top = window.pageYOffset + target.getBoundingClientRect().top - clearance;
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: still ? 'auto' : 'smooth' });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var link = e.target.closest('[data-product-reviews-link]');
    if (!link) return;
    // The link is the no-JS path, so leave a modified click to the browser.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;

    /* From inside a dialog the link always navigates. The quick add sheet opens over any
       page, including a product page, and the reviews on that page belong to a different
       product than the one in the sheet — scrolling there would be plainly wrong. */
    if (link.closest('dialog')) return;

    var target = reviews();
    // Not this page — a collection, say. Let it navigate.
    if (!target) return;

    e.preventDefault();
    scrollTo(target);
  });

  // Arriving from another page: the fragment names no real element, so it is honoured here.
  function onArrival() {
    if (window.location.hash !== HASH) return;
    var target = reviews();
    if (target) scrollTo(target);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onArrival);
  } else {
    onArrival();
  }
})();
